import React from "react";
import applicationName from "./applicationName";
import t from "./translate";

export default function SchoolBridgeLoader({ label = t("shared.school_bridge_loader.loading_data"), className = "", compact = false }) {
  const resolvedApplicationName = applicationName();

  return (
    <div className={`flex justify-center ${compact ? "px-3 py-4" : "px-6 py-12"} ${className}`}>
      <div className={`flex w-full flex-col items-center border border-slate-200 bg-slate-50/90 text-center shadow-[0_24px_60px_rgba(15,23,42,0.08)] ${compact ? "max-w-none rounded-[24px] px-5 py-5" : "max-w-sm rounded-[32px] px-8 py-10"}`}>
        <div className="pl pl-kinetic-1" aria-hidden="true">
          <div className="pl__dot" />
          <div className="pl__dot" />
          <div className="pl__dot" />
          <div className="pl__dot" />
        </div>

        <div className="mt-5 pl pl-kinetic-2" aria-hidden="true">
          <div className="pl__ring" />
          <div className="pl__ring" />
        </div>

        <p className={`${compact ? "mt-4" : "mt-6"} text-sm font-semibold uppercase tracking-[0.28em] text-brand-700`}>{resolvedApplicationName}</p>
        <p className="mt-3 text-sm text-slate-500">{label}</p>
      </div>
    </div>
  );
}
